<template>
  <div class="base-form-div">
    <el-form
      size="mini"
      :label-position="labelPosition"
      label-width="80px"
      :model="formSet"
    >
      <el-form-item label="名称">
        <el-input v-model="name"></el-input>
      </el-form-item>
      <el-form-item label="材质类型">
        <el-select
          @change="changeMaterialType"
          v-model="formSet.materialType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in optionsType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="
          formSet.materialType == 'ColorMaterialProperty' ||
          formSet.materialType == 'ImageMaterialProperty' ||
          formSet.materialType == 'GridMaterialProperty'
        "
        label="填充颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item v-show="formSet.materialType == 'ImageMaterialProperty'" label="图片">
        <el-select v-model="formSet.materialOption.image" placeholder="请选择">
          <el-option
            v-for="item in optionsImage"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'ImageMaterialProperty'"
        label="是否透明"
      >
        <el-switch
          v-model="formSet.materialOption.transparent"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'ImageMaterialProperty'"
        label="X重复次数"
      >
        <el-input-number
          v-model="formSet.materialOption.repeatX"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'ImageMaterialProperty'"
        label="Y重复次数"
      >
        <el-input-number
          v-model="formSet.materialOption.repeatY"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'GridMaterialProperty'"
        label="填充透明度"
      >
        <el-input-number
          v-model="formSet.materialOption.cellAlpha"
          :step="0.1"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'GridMaterialProperty'"
        label="网格数量"
      >
        <el-input-number
          v-model="formSet.materialOption.lineCount"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'GridMaterialProperty'"
        label="网格宽度"
      >
        <el-input-number
          v-model="formSet.materialOption.lineThickness"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="
          formSet.materialType == 'StripeMaterialProperty' ||
          formSet.materialType == 'CheckerboardMaterialProperty'
        "
        label="主色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.evenColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="
          formSet.materialType == 'StripeMaterialProperty' ||
          formSet.materialType == 'CheckerboardMaterialProperty'
        "
        label="衬色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.oddColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="
          formSet.materialType == 'StripeMaterialProperty' ||
          formSet.materialType == 'CheckerboardMaterialProperty'
        "
        label="数量"
      >
        <el-input-number
          v-model="formSet.materialOption.repeat"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'TextImageMaterialProperty'"
        label="文本"
      >
        <el-input v-model="formSet.materialOption.text"></el-input>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'TextImageMaterialProperty'"
        label="文本颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.fillColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'TextImageMaterialProperty'"
        label="文本大小"
      >
        <el-input-number
          v-model="formSet.materialOption.fontSize"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'TextImageMaterialProperty'"
        label="内边距"
      >
        <el-input-number
          v-model="formSet.materialOption.padding"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType == 'TextImageMaterialProperty'"
        label="是否有背景"
      >
        <el-switch
          v-model="formSet.materialOption.hasBackground"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        v-show="
          formSet.materialType == 'TextImageMaterialProperty' &&
          formSet.materialOption.hasBackground
        "
        label="背景颜色"
      >
        <el-color-picker
          :predefine="predefineColors"
          show-alpha
          v-model="formSet.materialOption.backgroundColor"
        ></el-color-picker>
      </el-form-item>
      <el-form-item
        v-show="formSet.materialType != 'ColorMaterialProperty'"
        label="材质方向"
      >
        <el-input-number
          v-model="formSet.stRotation"
          controls-position="right"
          :max="360"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="显示层级">
        <el-input-number
          v-model="formSet.zIndex"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="是否贴地">
                <el-switch v-model="formSet.clampToGround" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
            </el-form-item> -->
    </el-form>
    <div class="form-bottom">
      <!-- <el-button class="base-button" size="mini" type="primary" @click="confirmPlot">确定</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="savePlot"
        >保存</el-button
      >
      <!-- <el-button class="base-button" size="mini" type="primary" @click="exportPlot">导出</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="deletePlot"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
import { createMark, deleteByMarkId } from "@/api/vectorPlot/index.js";
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js";
import * as Help from "@/components/PlanEditor/Actions/help.js";
let entity;
export default {
  props: ["subData"],
  data() {
    return {
      predefineColors: ["#ff0000", "#0000ff", "#00ff00", "#00ffff"],
      optionsImage: [
        {
          value: NG_Server + "/gisData/贴图/装备/BgSub_军人.png",
          label: "军人",
        },
        {
          value: NG_Server + "/gisData/贴图/装备/BgSub_99式坦克.png",
          label: "99式坦克",
        },
        {
          value: NG_Server + "/gisData/贴图/装备/BgSub_歼-10C.png",
          label: "歼-10C",
        },
        {
          value: NG_Server + "/gisData/贴图/草坪/草坪2.jpg",
          label: "草坪",
        },
        {
          value: NG_Server + "/gisData/贴图/地面/地砖1.jpg",
          label: "地面",
        },
        {
          value: NG_Server + "/gisData/贴图/墙面/楼面3.jpg",
          label: "墙面",
        },
        {
          value: NG_Server + "/gisData/贴图/水面/水面1.jpg",
          label: "水面",
        },
      ],
      optionsType: StyleUtil.getPolygonTypes(),
      labelPosition: "left",
      formSet: {
        materialType: "ColorMaterialProperty",
        materialOption: {
          color: "",
          image: NG_Server + "/gisData/贴图/草坪/草坪2.jpg",
        },
        stRotation: 0,
        zIndex: 0,
      },
      isCalculate: false,
      name: "面",
    };
  },

  watch: {
    formSet: {
      // 数据变化时执行的逻辑代码
      handler(newObj, oldObj) {
        if (this.isCalculate) {
          StyleUtil.setStyle2Entity(newObj, entity, "rectangle");
        }
      },
      // 开启深度监听
      deep: true,
      immediate: false,
    },
  },

  created() {
    if (typeof this.subData == "function") {
      entity = this.subData();
    } else {
      entity = this.subData.entity;
    }
    this.name = entity.markName || entity.typeName;
    //回显
    if (entity["rectangle"]["attr"] && entity["rectangle"]["attr"].materialType) {
      this.formSet.materialType = entity["rectangle"]["attr"].materialType;
    }
    this.changeMaterialType();
    this.isCalculate = true;
  },

  methods: {
    confirmPlot() {
      StyleUtil.setStyle2Entity(this.formSet, entity, "rectangle");
    },
    changeMaterialType() {
      let style = StyleUtil.getEntity2Style(this.formSet, entity, "rectangle");
      this.formSet = style;
    },
    savePlot() {
      let style = StyleUtil.getEntity2Style(this.formSet, entity, "rectangle");
      console.log(style);
      //StyleUtil.setStyle2Entity(this.formSet, entity, "rectangle");
      let data = {
        extType: entity.typeName,
        editPositions: JSON.stringify(entity.attrPlot.edit_positions),
        // styleAttr: JSON.stringify(entity["rectangle"]["attr"]),
        styleAttr: JSON.stringify(style),
        postureAttr: "",
        userId: 111,
        markId: entity.id,
        markName: this.name,
      };
      console.log(data);
      let action = {};
      action.name = this.name;
      action.type = "commonPlot";
      action.typeName = "常用标绘";
      action.delay = 1;
      action.data = data;
      if (entity.isAlreadyPlotflag) {
        entity.markName = this.name;
        entity.update(action);
        this.$parent.close();
        return;
      }
      if (typeof this.subData != "function") {
        this.subData.update(action);
        this.$parent.close();
        return;
      }
      if (entity.isPlotflag) {
        entity.isPlotflag = false;
        entity.markName = this.name;
        this.$bus.$emit("addActionObj", action);
        Help.addEntityArr(entity);
        this.$parent.close();
        return;
      }
      createMark(data)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "保存成功,请到我的标绘中进行查看！",
            type: "success",
            duration: 3 * 1000,
          });
          this.$bus.$emit("vectorPlot-list");

          entity.markName = data.markName;
        })
        .catch((err) => {
          console.err(err);
        });
    },
    exportPlot() {},
    deletePlot() {
      if (entity.isPlotflag) {
        StyleUtil.deletePlot(entity);
        this.$parent.close();
        return;
      }
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteByMarkId(entity.id).then((res) => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("vectorPlot-list");
            StyleUtil.deletePlot(entity);
            this.$parent.close();
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.base-form-div {
  padding: 20px;
}

.form-bottom {
  text-align: center;
  border-top: 1px solid rgba(153, 153, 153, 0.5);
  padding-top: 20px;
}
</style>
